import i18n from "i18next";
import { initReactI18next, Trans } from "react-i18next";

i18n
.use(initReactI18next)
.init({
    resources:{
        en: {
            translations: {
           "According to Wikipedia,Science fiction is a genre of speculative fiction which typically deals with imaginative and futuristic concepts such as advanced science and technology, space exploration, time travel, parallel universes, and extraterrestrial life. It has been called the \"literature of ideas\", and it often explores the potential consequences of scientific, social, and technological innovations":
           "According to Wikipedia,Science fiction is a genre of speculative fiction which typically deals with imaginative and futuristic concepts such as advanced science and technology, space exploration, time travel, parallel universes, and extraterrestrial life. It has been called the \"literature of ideas\", and it often explores the potential consequences of scientific, social, and technological innovations",
                "News":"News",
                "Categories":"Categories",
                "Blog":"Blog",
                "Sign Up":"Sign Up",
                "Home":"Home",
                "Time travel":"Time travel",
                "Your Name":"Your Name",
                "Your Email":"Your Email",
                "Parallels universe":"Parallels universe",
                "Extraterrestrial life":"Extraterrestrial life",
                "Space exploration":"Space exploration",
                "Artificial Intelligence":"Artificial Intelligence",
                "Virtual reality":"Virtual reality",
                "Your favorite Category":"Your favorite Category",
                "Read More":"Read More",
                "Show Less":"Show Less",
                "But first of all Let's fix the questions about what Artificial Intelligence. Are Artificial Intelligence going the take control of the world? What are some of the biggest threats about artificial intelligence?":" But first of all Let's fix the questions about what Artificial Intelligence. Are Artificial Intelligence going the take control of the world? What are some of the biggest threats about artificial intelligence?",
                "Subscribe to receive informations via email":"Subscribe to receive informations via email",
                "Sci-Fiction latest News":"Sci-Fiction latest News",
                "Check the latest news About Science-Fictions and also its applications and you could realise that it's not as fiction":"Check the latest news About Science-Fictions and also its applications and you could realise that it's not as fiction",
                "Check the latest news About Science-Fictions according to category and how it could serve humanity":"Check the latest news About Science-Fictions according to category and how it could serve humanity",
                "But first of all let check what SCI-FI is not about or what you could heard about SCI-FI that is not true":
                    " But first all let check what SCI-FI is not about or what you could heard about SCI-FI that is not true"

            }
        },
        fr:{
            translations:{
                "According to Wikipedia,Science fiction is a genre of speculative fiction which typically deals with imaginative and futuristic concepts such as advanced science and technology, space exploration, time travel, parallel universes, and extraterrestrial life. It has been called the \"literature of ideas\", and it often explores the potential consequences of scientific, social, and technological innovations":
                "Selon Wikipedia la science fiction est un genre de spéculation qui a trait avec l'imagination et les concepts futuristes tel que les progrès scientifiques et techniques, l'exploration spaciale, les voyages dans le temps, les univers parallèles et les extra-terrestes elle a été appelée la litterature des idées et elle explore souvent les conséquences potentielles scientifiques et socio-technologiques de l'innovation",
                "News":"Actualités",
                "Categories":"Catégories",
                "Blog":"Blog",
                "Sign Up":"Inscription",
                "Home":"Acceuil",
                "Time travel":"Voyage dans le temps",
                "Parallels universe":"Univers parallèles",
                "Extraterrestrial life":"Vie Extra-terrestre",
                "Space exploration":"Conquête Spaciale",
                "Artificial Intelligence":"Intelligence Artificielle",
                "Virtual reality":"Réalité virtuelle",
                "Read More":"Voir Plus",
                "Show Less":"Voir moins",
                "Your Name":"Votre Nom",
                "Your Email":"Votre Email",
                "Your favorite Category":"Votre Catégorie Favorite",
                "But first of all Let's fix the questions about what Artificial Intelligence. Are Artificial Intelligence going the take control of the world? What are some of the biggest threats about artificial intelligence?":"Tout d'abord répondons aux questions de savoir c'est quoi l'intelligence artificielle, est ce que l'intelligence artificielle va controler le monde et surtout quelles les principales menaces de l'intelligence artificielles?",
                "Subscribe to receive informations via email":"Inscrivez vous pour recevoir les informations via Email ",
                "Sci-Fiction latest News":"SCI-FI Derniers nouvelles",
                "Check the latest news About Science-Fictions and also its applications and you could realise that it's not as fiction":
                "Obtenez les dernières nouvelles de lam science fiction et ses applications et vous seriez surpris que ce n'est pas si fictif",
                "Check the latest news About Science-Fictions according to category and how it could serve humanity":
                    "Restez au courant des dernières avancées sur la science fiction et comment elle peut servir l'humanité",
                "But first of all let check what SCI-FI is not about or what you could heard about SCI-FI that is not true":
                "Avant tout verifiez un peu ce qu'est la science fiction ou ce que vous pourriez avoir entendu à propos qui n'est pas vrai "
            }

        }

    },

    fallbackLng:'en',
    debug: true,
    ns:['translations'],
    defaultNS:'translations',
    keySeparator:false,
    interpolation:{
        escapeValue:false,
        formatSeparator:','
    },
    react: {
        wait:true
    }
})

export default i18n;